var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 664,
    height: 570,
    viewBox: "0 0 664 570",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 233,
    cy: 233,
    r: 205.5,
    stroke: "black",
    strokeWidth: 55
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M619.993 563.892C630.782 572.508 646.513 570.747 655.129 559.958C663.745 549.169 661.984 533.439 651.195 524.822L619.993 563.892ZM395.071 384.263L619.993 563.892L651.195 524.822L426.273 345.194L395.071 384.263Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.863a360253213de8d7ea9f5ca5233e57.svg";
export { ForwardRef as ReactComponent };